/**
 * NotificationBell Component
 * Bell icon with badge showing unread notification count
 */

import React, { useState } from 'react';
import { Badge, Dropdown } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import { useNotificationCount } from '@/hooks/useNotifications';
import { NotificationDropdown } from './NotificationDropdown';
import './NotificationBell.css';

export const NotificationBell: React.FC = () => {
  const [open, setOpen] = useState(false);
  const { data: counts, isLoading } = useNotificationCount();

  return (
    <Dropdown
      open={open}
      onOpenChange={setOpen}
      dropdownRender={() => (
        <NotificationDropdown onClose={() => setOpen(false)} />
      )}
      trigger={['click']}
      placement="bottomRight"
    >
      <Badge
        count={counts?.unread || 0}
        overflowCount={99}
        className="notification-bell-badge"
      >
        <BellOutlined className="notification-bell-icon" />
      </Badge>
    </Dropdown>
  );
};
